/**
 * UTM models
 * This file contains the core UTM models as OpenAPI 2.0 compliant definitions. Some key caveats when using/referencing this API:   1. The API on its own is insufficeint to develop a USS or other UTM   component.  For example, the USS Specification is needed to understand   how and when to use the various endpoints and provides more details on   security features that cannot be captured in the API docs.   2. There is not a unified time synchronization approach in UTM currently.   As such, times provided from one server MUST NOT be validated against each other.   For example, if a sending server states that a data element   was sent at 10:00:23, but the receiving server thinks it is currently   10:00:22, the receiving server must not reject the data submission.  As   we develop and roll out the time synchronization scheme for the USS   Network, we will add appropriate validation requirements to the API   documentation.   3. On the contrary, times must be validated for consistency within a   given data submission.  For example, if a server states that it sends   a data instance at 10:00:23 and one of the other data elements states   that a measurement was performed at 10:00:24, then the receiving server   must reject that data submission. Some of these checks are explictly   stated in the descriptions below. If you recognize any such checks that   are not documented, please submit an issue report on github.   4. These token SUBJECT validations are required for security.   For PUT Operation to modify an existing operation, the token SUBJECT claim upon modification MUST equal the token SUBJECT claim for the initial Operation.   For PUT Message associated with an Operation gufi, the token SUBJECT claim used for PUT Message MUST equal the token SUBJECT claim for the initial operation.     This check is performed if the initial operation exists, so as to not preclude receiving emergency messages.   For PUT Position associated with an Operation gufi, the token SUBJECT claim used for PUT Position MUST equal the token SUBJECT claim for the initial operation.     This check is performed only if the initial operation exists, so as to not preclude receiving emergency position reports.
 *
 * The version of the OpenAPI document: v4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IAltitude } from './altitude';
import { IPoint } from './point';


export interface IPosition { 
    altitude_gps: IAltitude;
    /**
     * Number of satellites used in calculating the altitude.
     */
    altitude_num_gps_satellites: number;
    comments?: string;
    /**
     * Each position will be assigned a UUIDv4 by the USS managing the referenced operation.  Any system recieving this position object MUST NOT modify this identifier.
     */
    enroute_positions_id: string;
    /**
     * Each operation has an GUFI assigned upon submission. Required upon PUTting a new position. It is a JSON string, but conforms to the UUID version 4 specification
     */
    gufi: string;
    /**
     * The horizontal dilution of precision as provided by the onboard GPS.
     */
    hdop_gps: number;
    location: IPoint;
    /**
     * The time the position was measured. Likely the time provided with the GPS position reading. Position time_measured < time_sent MUST be true.
     */
    time_measured: string;
    /**
     * The time the position was sent by the USS as measured by that USS\'s system time. Position time_measured <= time_sent MUST be true.
     */
    time_sent: string;
    /**
     * The direction of travel relative to track_bearing_reference in degrees. Position track_bearing value MUST be >= 0.0 and < 360.0. Note that FIXM allows for the value of 360.0, while UTM does not.  The reason is for clarity by not allowing two numbers (0.0 and 360.0) to represent the same measurement.
     */
    track_bearing: number;
    /**
     * A code indicating the direction of the zero bearing. TRUE_NORTH  This value indicates that the direction is relative to True North. MAGNETIC_NORTH  This value indicates that the direction is relative to Magnetic North. This field is equivalent to
     */
    track_bearing_reference: IPosition.TrackBearingReferenceEnum;
    /**
     * The reference quantities used to express the value of angles. [ISO 19103, chapter 6.5.7.10] As in FIXM, only a single option is provided (degrees). Including this field allows for clarity in the data provided and allows for the potential of other units of measure in the future.
     */
    track_bearing_uom: IPosition.TrackBearingUomEnum;
    /**
     * Ground speed int the direction of travel, in units as specifed by track_ground_speed_units. Position track_ground_speed MUST be >= 0.0.
     */
    track_ground_speed: number;
    /**
     * The reference quantities used to express the value of ground speed as provided in track_ground_speed. KT: Knots. FIXM allows KT (knots) and KM_H (kilometers per hour) but we only allow the KT choice.
     */
    track_ground_speed_units: IPosition.TrackGroundSpeedUnitsEnum;
    /**
     * The name of the entity providing UAS Support Services. Populated by the service discovery system based on credential information provided by the USS. The maximum and minimum character length is based on a usable domain name, and considering the maximum in RFC-1035.
     */
    uss_name: string;
    /**
     * An identifier that supplies information about the USS from the discovery perspecitve.  This field is currently vague due to research on the appropriate discovery approach.  It will be tightened when an operational system decides on the approach to discovery. For Gridded USS Discovery, this should be an x,y,z string where x and y are the coords of the grid and z is the zoom level.  For example:  \"110,117,10\" For FIMS Discovery, this should be the uss_instance_id which is a UUID.
     */
    discovery_reference?: string;
    /**
     * The vertical dilution of precision as provided by the onboard GPS.
     */
    vdop_gps: number;
}
export namespace IPosition {
    export type TrackBearingReferenceEnum = 'TRUE_NORTH' | 'MAGNETIC_NORTH';
    export const TrackBearingReferenceEnum = {
        TRUENORTH: 'TRUE_NORTH' as TrackBearingReferenceEnum,
        MAGNETICNORTH: 'MAGNETIC_NORTH' as TrackBearingReferenceEnum
    };
    export type TrackBearingUomEnum = 'DEG';
    export const TrackBearingUomEnum = {
        DEG: 'DEG' as TrackBearingUomEnum
    };
    export type TrackGroundSpeedUnitsEnum = 'KT';
    export const TrackGroundSpeedUnitsEnum = {
        KT: 'KT' as TrackGroundSpeedUnitsEnum
    };
}


